import mergeConfig from './core/mergeConfig';
import { createInstance, axios } from './axios';
// Factory for creating new instances
export function originalCreateInstance(instanceConfig) {
    return createInstance(mergeConfig(axios.defaults, instanceConfig));
}
export default axios;
//# sourceMappingURL=index.js.map